import { LOGIN_SUCCESS } from "../../../constants/actionTypes"

export default (payload:any) => (dispatch:any) => {
    dispatch({
        type: LOGIN_SUCCESS,
        payload: payload
    })
}